import { render } from "./Teknologi.vue?vue&type=template&id=39bbc2be"
import script from "./Teknologi.vue?vue&type=script&lang=js"
export * from "./Teknologi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__